enum HighlighterLanguage {
	AUTO = "auto",
	EMBED = "embed",
	_1C = "1c",
	ABNF = "abnf",
	ACCESSLOG = "accesslog",
	ACTIONSCRIPT = "actionscript",
	ADA = "ada",
	ANGELSCRIPT = "angelscript",
	APACHE = "apache",
	APPLESCRIPT = "applescript",
	ARCADE = "arcade",
	CPP = "cpp",
	ARDUINO = "arduino",
	ARMASM = "armasm",
	XML = "xml",
	HTML = "html",
	ASCIIDOC = "asciidoc",
	ASPECTJ = "aspectj",
	AUTOHOTKEY = "autohotkey",
	AUTOIT = "autoit",
	AVRASM = "avrasm",
	AWK = "awk",
	AXAPTA = "axapta",
	BASH = "bash",
	BASIC = "basic",
	BNF = "bnf",
	BRAINFUCK = "brainfuck",
	CAL = "cal",
	CAPNPROTO = "capnproto",
	CEYLON = "ceylon",
	CLEAN = "clean",
	CLOJURE = "clojure",
	CMAKE = "cmake",
	COFFEESCRIPT = "coffeescript",
	COQ = "coq",
	COS = "cos",
	CRMSH = "crmsh",
	CRYSTAL = "crystal",
	CS = "cs",
	CSP = "csp",
	CSS = "css",
	D = "d",
	MARKDOWN = "markdown",
	DART = "dart",
	DELPHI = "delphi",
	DIFF = "diff",
	DJANGO = "django",
	DNS = "dns",
	DOCKERFILE = "dockerfile",
	DOS = "dos",
	DSCONFIG = "dsconfig",
	DTS = "dts",
	DUST = "dust",
	EBNF = "ebnf",
	ELIXIR = "elixir",
	ELM = "elm",
	RUBY = "ruby",
	ERB = "erb",
	ERLANG_REPL = "erlang-repl",
	ERLANG = "erlang",
	EXCEL = "excel",
	FIX = "fix",
	FLIX = "flix",
	FORTRAN = "fortran",
	FSHARP = "fsharp",
	GAMS = "gams",
	GAUSS = "gauss",
	GCODE = "gcode",
	GHERKIN = "gherkin",
	GLSL = "glsl",
	GML = "gml",
	GO = "go",
	GOLO = "golo",
	GRADLE = "gradle",
	GROOVY = "groovy",
	HAML = "haml",
	HANDLEBARS = "handlebars",
	HASKELL = "haskell",
	HAXE = "haxe",
	HSP = "hsp",
	HTMLBARS = "htmlbars",
	HTTP = "http",
	HY = "hy",
	INFORM7 = "inform7",
	INI = "ini",
	IRPF90 = "irpf90",
	ISBL = "isbl",
	JAVA = "java",
	JAVASCRIPT = "javascript",
	JBOSS = "jboss",
	JSON = "json",
	JULIA = "julia",
	KOTLIN = "kotlin",
	LASSO = "lasso",
	LDIF = "ldif",
	LEAF = "leaf",
	LESS = "less",
	LISP = "lisp",
	LIVECODESERVER = "livecodeserver",
	LIVESCRIPT = "livescript",
	LLVM = "llvm",
	LSL = "lsl",
	LUA = "lua",
	MAKEFILE = "makefile",
	MATHEMATICA = "mathematica",
	MATLAB = "matlab",
	MAXIMA = "maxima",
	MEL = "mel",
	MERCURY = "mercury",
	MIPSASM = "mipsasm",
	MIZAR = "mizar",
	PERL = "perl",
	MOJOLICIOUS = "mojolicious",
	MONKEY = "monkey",
	MOONSCRIPT = "moonscript",
	N1QL = "n1ql",
	NGINX = "nginx",
	NIMROD = "nimrod",
	NIX = "nix",
	NSIS = "nsis",
	OBJECTIVEC = "objectivec",
	OCAML = "ocaml",
	OPENSCAD = "openscad",
	OXYGENE = "oxygene",
	PARSER3 = "parser3",
	PF = "pf",
	PGSQL = "pgsql",
	PHP = "php",
	PLAINTEXT = "plaintext",
	PONY = "pony",
	POWERSHELL = "powershell",
	PROCESSING = "processing",
	PROFILE = "profile",
	PROLOG = "prolog",
	PROPERTIES = "properties",
	PROTOBUF = "protobuf",
	PUPPET = "puppet",
	PUREBASIC = "purebasic",
	PYTHON = "python",
	Q = "q",
	QML = "qml",
	R = "r",
	REASONML = "reasonml",
	RIB = "rib",
	ROBOCONF = "roboconf",
	ROUTEROS = "routeros",
	RSL = "rsl",
	RULESLANGUAGE = "ruleslanguage",
	RUST = "rust",
	SAS = "sas",
	SCALA = "scala",
	SCHEME = "scheme",
	SCILAB = "scilab",
	SCSS = "scss",
	SHELL = "shell",
	SMALI = "smali",
	SMALLTALK = "smalltalk",
	SML = "sml",
	SQF = "sqf",
	SQL = "sql",
	STAN = "stan",
	STATA = "stata",
	STEP21 = "step21",
	STYLUS = "stylus",
	SUBUNIT = "subunit",
	SWIFT = "swift",
	TAGGERSCRIPT = "taggerscript",
	YAML = "yaml",
	TAP = "tap",
	TCL = "tcl",
	TEX = "tex",
	THRIFT = "thrift",
	TP = "tp",
	TWIG = "twig",
	TYPESCRIPT = "typescript",
	VALA = "vala",
	VBNET = "vbnet",
	VBSCRIPT = "vbscript",
	VBSCRIPT_HTML = "vbscript-html",
	VERILOG = "verilog",
	VHDL = "vhdl",
	VIM = "vim",
	X86ASM = "x86asm",
	XL = "xl",
	XQUERY = "xquery",
	ZEPHIR = "zephir"
}

export default HighlighterLanguage;